import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_957_4055)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M8 10C7.735 10 7.48 10.105 7.293 10.293C7.105 10.48 7 10.735 7 11C7 12.707 7 16 7 16H0V7L8 0L16 7V16H9V11C9 10.735 8.895 10.48 8.707 10.293C8.52 10.105 8.265 10 8 10ZM8 8C7.204 8 6.441 8.316 5.879 8.879C5.316 9.441 5 10.204 5 11V14H2V7.908L8 2.658L14 7.908V14H11V11C11 10.204 10.684 9.441 10.121 8.879C9.559 8.316 8.796 8 8 8Z",
    fill: "#020203"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_957_4055" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "16",
      height: "16",
      fill: "white"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}